import { Component, OnInit, ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from 'underscore';
import { SitesService } from '../sites.service';
import { EnterpriseService } from '../../enterprise/enterprise.service';
import { NotificationMessageService } from '../../shared/notification-message/notification-message.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { UsersService } from 'src/app/users/users.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-site-edit-page',
	templateUrl: './site-edit-page.component.html',
	styleUrls: ['./site-edit-page.component.css']
})
export class SiteEditPageComponent implements OnInit {

	enterpriseList = <any>[];
	customerEnterprises = <any>[];
	enterprise_ids = [];
	customerId = 0;
	site: any = {
		id: 0,
		siteid: 0,
		customerid: 0,
		enterprise_ids: []
	}
	map: any = {
		latitude: this.sitesService.defaultMapLocation.latitude,
		longitude: this.sitesService.defaultMapLocation.longitude
	};
	mapZoom = 3;
	isSiteLoaded = false;
	customerInfo: any;
	currentUser: any;

	constructor(
		private chRef: ChangeDetectorRef,
		private route: ActivatedRoute,
		private sitesService: SitesService,
		private router: Router,
		private enterpriseService: EnterpriseService,
		private notificationMessage: NotificationMessageService,
		private sideMenuService: SideMenuService,
		private navigation: NavigationService,
		private el: ElementRef,
		private renderer: Renderer2,
		private usersService: UsersService,
		private commonService: CommonService,
		private translateService: TranslateService
	) {}

	ngOnInit() {
		this.currentUser = this.usersService.getCurrentUser();
		// creating a site is controlled by "Create Site", editing it by "Site Management"
		const isNewSite = !Number(this.route.snapshot?.params?.['siteId']);
		const siteAccessFunction = isNewSite ? 'create_site' : 'site_management';
		if (!this.currentUser.isSCT || !this.usersService.hasAccessFunction(siteAccessFunction))
			return this.router.navigate(['/unauthorized']);

		this.sideMenuService.hide();
		this.route.params.subscribe(
			params => {
				this.site.id = Number(params['siteId']) || 0;
				this.customerId = Number(params['customerId']) || 0;

				if (this.site.id) {
					this.getSite();
				} else {
					this.getCustomerInfo();
					this.site['installation_date'] = new Date(new Date().setHours(0, 0, 0, 0));
					this.site['is_smart_rebates'] = true;
					this.map.latitude = this.sitesService.defaultMapLocation.latitude;
					this.map.longitude = this.sitesService.defaultMapLocation.longitude;
					this.isSiteLoaded = true;
				}
			}
		);
	}


	getSite() {
		this.sitesService.getSites([this.site.id], {get_enterprise_list: true, formattedDate: true}).subscribe(
			data => {
				if(!data['site'].length)
					return this.goBack();

				this.site = data['site'][0];
				this.customerInfo = data['customerInfo'][0];
				this.map['latitude'] = this.site['latitude'];
				this.map['longitude'] = this.site['longitude'];
				this.mapZoom = 15;
				this.site['enterprise_ids'] = _.pluck(this.site['site_enterprise'], "enterprise_id");
				this.site['installation_date'] = new Date(new Date(this.site['installation_date']).setHours(0, 0, 0, 0));
				this.handleSiteEnterprises(data['enterprise_list']);
				//Only keep usable enterprises
				let enterpriseIdsList = _.pluck(this.enterpriseList, 'id');
				this.site['enterprise_ids'] = _.intersection(this.site['enterprise_ids'], enterpriseIdsList);
				this.isSiteLoaded = true;
				this.commonService.setPageTabTitle(`${this.translateService.instant('site.edit_site')} - ${this.site.customer_name} - ${this.site.name}`);
			}
		);
	}

	getEnterpriseList() {
		 this.enterpriseService.getEnterprises({site_edit: true, source: 'site_edit'}).subscribe((enterpriseData: any)=> {
			this.handleSiteEnterprises(enterpriseData);
		});
	}

	handleSiteEnterprises(enterpriseData) {
		if (this.customerInfo.customer_enterprises) {
			this.customerEnterprises = enterpriseData.filter((item) => this.customerInfo.customer_enterprises.includes(item.id));
			this.enterpriseList = enterpriseData.filter((item) => !this.customerInfo.customer_enterprises.includes(item.id));
			this.site.customer_enterprises = this.customerInfo.customer_enterprises || [];
		} else {
			this.enterpriseList = enterpriseData;
		}
	}

	getCustomerInfo() {
		this.sitesService.getCustomerSites(this.customerId, {get_customers: true}).subscribe((response: any) => {
			this.customerInfo = response.customerInfo[0] || {};
			this.commonService.setPageTabTitle(`${this.customerInfo.name} ${this.translateService.instant('site.add')}`);
			this.customerEnterprises = this.customerInfo.customer_enterprises;
			this.getEnterpriseList();
		});
	}

	saveSite() {
		this.resetForm();
		let tempSite = Object.assign({}, this.site);
		let insDate = new Date(tempSite['installation_date']);
		tempSite['installation_date'] = Math.floor((-insDate.getTimezoneOffset() * 60000 + insDate.getTime()) / 1000);
		tempSite['customer_id'] = this.customerId;
		tempSite.enterprise_ids = [...tempSite.enterprise_ids, ...(tempSite.customer_enterprises || [])];
		delete tempSite.customer_enterprises;
		if (!tempSite['customer_id']) {
			return;
		}

		const invalidFields = this.validateIotemeterData(tempSite);
		if (invalidFields.length)
			return this.highlightInvalidFields(invalidFields);

		this.sitesService.saveSite(tempSite).subscribe((data: any) => {
			if (data) {
				if(data.api_status) {
					let msg = 'globalErrMsg';

					switch (data.api_status) {
						case 4:
							msg = 'translate|site.rename_special_site_err';
							break;
						case 5:
						case 6:
							const form = this.el.nativeElement;
							const ele = form.querySelectorAll('[name=name]');
							if (ele && ele[0])
								this.renderer.addClass(ele[0], 'invalid-input');

							msg = 'translate|site.reserved_site_name';
							if (data.api_status == 6)
								msg = 'translate|site.site_name_cannot_changed';

							break;
						case 7:
							msg = 'translate|site.site_name_already_exist';
							break;
						case 8:
							msg = 'translate|site.iotemeter_site_already_linked';
							break;
						default:
							break;
					}
					this.notificationMessage.setMessage(msg, { clearOnXTimeNavigate: 1 });
				} else {
					this.notificationMessage.setMessage('globalSuccessMsg');
					this.goBack();
				}
			} else {
				this.notificationMessage.setMessage('globalErrMsg', {clearOnXTimeNavigate: 1});
			}
		});
	}

	updateSiteCoords(coords) {
		if(coords.selectedFromMapbox)
			this.site.address_manually_edited = false
		this.site['latitude'] = coords['lat'];
		this.site['longitude'] = coords['lng'];
		if (!this.site.address_manually_edited || !this.site.id)
			this.site['address'] = coords['address'];
		this.site['country_id'] = coords['country'];
		this.site['state_id'] = coords['state'];
		this.site['city'] = coords['city'];
		this.chRef.detectChanges();
	}

	goBack() {
		this.navigation.goBack('/');
	}

	validateIotemeterData(tempSite) {
		const invalid: string[] = [];

		if ('is_contain_iotemeter_devices' in tempSite && tempSite.is_contain_iotemeter_devices) {
			if (!tempSite.iotemeter_customer_id) {
				invalid.push('iotemeter_customer_id');
				return invalid;
			}

			if (!tempSite.iotemeter_site_id) {
				invalid.push('iotemeter_site_id');
				return invalid;
			}
		}

		return invalid;
	}

	highlightInvalidFields(invalidFields) {
		let form = this.el.nativeElement;
		for(let invalidField of invalidFields){
			let ele = form.querySelectorAll('[name="'+invalidField+'"]');
			if(ele && ele[0])
				this.renderer.addClass(ele[0], 'invalid-input');
		}
		this.notificationMessage.setMessage('translate|g.invalid_input', {timeout: 20000, numberOfNavigate: 1});
	}

	resetForm(){
		let invalidInputs = this.el.nativeElement.querySelectorAll('.invalid-input');
		invalidInputs.forEach((item) => {
			item.classList.remove('invalid-input');
		});
	}
}
